'use client';
import type { PlateStaticProps } from 'platejs/static';

import { createSlateEditor } from 'platejs';
import { PlateStatic } from 'platejs/static';
import { useMemo } from 'react';
import { cn } from '../../utils/cn';
import { BaseEditorKit } from './editor/editor-base-kit';
import { BlockquoteElementStatic } from './ui/blockquote-node-static';
import { LinkElementStatic } from './ui/link-node-static';
import { ImageElementStatic } from './ui/media-image-node-static';
import { ParagraphElementStatic } from './ui/paragraph-node-static';
import { TableCellElementStatic, TableElementStatic, TableRowElementStatic } from './ui/table-node-static';

export interface PlateViewerProps extends Omit<PlateStaticProps, 'editor'> {
  className?: string;
}
export const PlateViewer = ({ value, className, ...props }: PlateViewerProps) => {
  const editor = useMemo(() => createSlateEditor({
    plugins: BaseEditorKit,
    value,
    components: {
      // [ParagraphPlugin.key]: ParagraphElementStatic,
      // [HeadingPlugin.key]: HeadingElementStatic,
      p: ParagraphElementStatic,
      // text-elements
      // h1: HeadingElementStatic,
      // h2: HeadingElementStatic,
      // h3: HeadingElementStatic,
      // h4: HeadingElementStatic,
      // h5: HeadingElementStatic,
      // h6: HeadingElementStatic,
      blockquote: BlockquoteElementStatic,
      a: LinkElementStatic,
      // media-elements
      img: ImageElementStatic,

      table: TableElementStatic,
      tr: TableRowElementStatic,
      td: TableCellElementStatic,
      th: TableCellElementStatic,

      // ul: BlockListStatic,
      // ol: BlockListStatic,
      // ol: ListElementStatic,
      // li: ListItemElementStatic,
      // code_block: CodeBlockElementStatic,

    },
  }), [value]);

  return (
    <PlateStatic
      editor={editor}
      className={cn(
        'group/editor',
        'relative w-full cursor-text select-text overflow-x-hidden whitespace-pre-wrap break-words',
        'rounded-md ring-offset-background focus-visible:outline-none',
        'placeholder:text-muted-foreground/80 **:data-slate-placeholder:top-[auto_!important] **:data-slate-placeholder:text-muted-foreground/80 **:data-slate-placeholder:opacity-100!',
        '[&_strong]:font-bold',
        className,
      )}
      {...props}
    />
  );
};
